import React from 'react'
import menuItems from './menuItems'
import Edit from '../crud/edit'
import MenuEditor from './MenuEditor'

const fields = [{
  name: 'Member Navigation Menu',
  prop: 'value',
  type: 'component',
  component: MenuEditor,
  componentProps: {
    pageFilter: page => page.requires_membership
  }
}]

const EditSettings = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Member Navigation Menu'
      fields={fields}
      apiPath='admin/settings/resources_menu'
      successRedirectPath='/settings/resources_menu'
      buildMenuItems={menuItems}
      disableDelete
    />
  )
}

export default EditSettings
